import api from '../token';

export const DeleteUser = async (dados) => {
  try {
    const response = await api.post('/deleteUser',dados);
    return response.data;
  } catch (error) {
    
    return [];
  }
};

